// The notes a scheduled email carries: the schedule's own, after a line saying
// which gadgets didn't load when the content was captured. The email service
// shows 'None' when there are no notes.
const buildScheduledNotes = ({
  notes,
  missingGadgets,
  contentLabel,
}: {
  notes: string;
  missingGadgets: string[];
  contentLabel: 'report' | 'dashboard';
}): string => {
  const ownNotes = notes === '' || notes === 'None' ? '' : notes;
  if (missingGadgets.length === 0) {
    return ownNotes === '' ? 'None' : ownNotes;
  }

  const warning = `Some content didn't load in time and is missing from this ${contentLabel}: ${missingGadgets.join(
    ', ',
  )}. Open it in FleetOps for the full view.`;
  return ownNotes === '' ? warning : `${warning}\n\n${ownNotes}`;
};

export default buildScheduledNotes;
